import LazyLoad from "react-lazyload";
import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import PageTitle from "../Component/PageTitle";
const Physics = () => {
  const homeMenu = [
    {
      label: "Curriculum",
      link: "",
      subMenu: [
        { label: "Primary Wing", link: "/primarywing" },
        { label: "Middle Wing", link: "/middleWing" },
        { label: "Senior Wing", link: "/seniorWing" },
        { label: "Curriculum", link: "/curriculum" },
      ],
    },

    {
      label: "Extended Classroom",
      link: "",
      subMenu: [
        { label: "Labs", link: "/mathmatics" },
        { label: "Excursions", link: "/excursions" },
        { label: "Library", link: "/library" },
        { label: "Field Trips", link: "/feildTrip" },
        { label: "Astronomy", link: "/astronomy" },
      ],
    },
    {
      label: "Sports",
      link: "",
      subMenu: [
        { label: "Sports", link: "/sports" },
        {
          label: "Achievements in Sports 2022-23",
          link: "/acheivementInSports",
        },
      ],
    },
    {
      label: "Arts",
      link: "",
      subMenu: [
        { label: "Performing Arts", link: "/music" },
        { label: "Visual Arts", link: "/visualArts" },
      ],
    },

    { label: "Houses", link: "/houses" },
    { label: "Assembly", link: "/assembly" },
    { label: "Book List", link: "/booklist" },
  ];
  return (
    <>
      <Header />
      <Breadcrumb breadImage="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/learning-app.jpg" />
      <Menu MenuItem={homeMenu} />
      <div className="padding-blk inner-page">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <PageTitle
                pageTitle="Facilities"
                breadEnd="Learning Approach"
                breadMid="Physics Lab"
              />
            </div>
          </div>
          <div className="row ">
            <div className="col-xl-12 mb-4">
              <h4 className="color-red">Physics</h4>
              <div class="lab-heading mb-4">
                <div class="lab-btn" id="mb-lab-btn">
                  <span>Labs</span>
                </div>
                <ul class="labs-list">
                  <li>
                    <a class="" href="/mathmatics">
                      Mathematics
                    </a>
                  </li>
                  <li>
                    <a class="inc-tlink-active" href="/physics">
                      Physics
                    </a>
                  </li>
                  <li>
                    <a class="" href="/biology">
                      Biology
                    </a>
                  </li>
                  <li>
                    <a class="" href="/chemistry">
                      Chemistry
                    </a>
                  </li>
                  <li>
                    <a class="" href="/language">
                      Language
                    </a>
                  </li>
                  <li>
                    <a class="" href="/computer">
                      Computer
                    </a>
                  </li>
                  <li>
                    <a class="" href="/robotics">
                      Robotics
                    </a>
                  </li>
                  <li>
                    <a class="" href="/hands-on-studio">
                      Hands On Studio
                    </a>
                  </li>
                  <li>
                    <a class="" href="/psychology">
                      Psychology
                    </a>
                  </li>
                  <li>
                    <a class="" href="/counseling-sen">
                      Counseling &amp; Sen{" "}
                    </a>
                  </li>
                </ul>
              </div>
              {/* <h5 className="text-center color-red mb-4"><i>Verbal communication is temporal and easily forgotten, but written reports exist for long periods and yield long-term benefits for the author and others.

    </i></h5> */}
              <p>
                Verbal communication is temporal and easily forgotten, but
                written reports exist for long periods and yield long-term
                benefits for the author and others.
              </p>
              <LazyLoad>
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/phy-lab1.jpg"
                  className="float-end wid-500 m-2"
                  alt="Lotus Valley Gurgaon"
                />
              </LazyLoad>
              <p>
                Scientific research is a group activity. Individual scientists
                perform experiments to test hypotheses about biological
                phenomena. After experiments are completed and duplicated,
                researchers attempt to persuade others to accept or reject their
                hypotheses by presenting the data and their interpretations.
              </p>
              <p>
                Laboratory is a place where investigation is done to ascertain
                the reality, verify all laws and principles claimed by
                scientists.
              </p>
              <p>
                A laboratory is a facility that provides controlled conditions
                in which scientific or technological research, experiments, and
                measurements may be performed.
              </p>
              <p>
                In our lab, we have multiple number of apparatus that can be
                used to measure such as dimensions of objects, viscosity,
                friction force, pressure, frequency, resistance etc. In our lab,
                we ensure that learners comprehend theoretical concepts by doing
                experiments themselves. It is more fun to learn through
                practicals and experiments than usual classroom lectures.
              </p>
              <p>
                Learners are encouraged to use these laboratories to learn
                through experiments. Every year latest instruments, specimens,
                charts etc. are purchased for the laboratories.
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default Physics;
